import { Observable } from 'rxjs';

export interface App {
  name: string;
  iconClass: string;
  type: string;
  url: string;
}

export abstract class AppData {
  abstract getApps(): Observable<App[]>;
}
